import { useState } from 'react';
import styles from './index.module.css';
import DOMPurify from 'dompurify';
const Id = ({ textData ,language}) => {
  const [color, setColor] = useState('white');
  return (
    <div className={`${styles.ctn} ${color}`}>
      <div>
        <h6
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text14']),
          }}
        ></h6>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text15']),
          }}
        ></h5>
        <div style={{
          width:"100%",
          height:'100%'
        }}>
          <img
            src={`http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-appearance-${color}-01.jpg`}
            alt=""
          />
        </div>

        <div
          className={styles.colorChangeButton}
          onClick={() => {
            if (color === 'black') {
              setColor('white');
            } else {
              setColor('black');
            }
          }}
        >
          <svg
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 20.6663C5.93729 20.6663 1.83337 16.5624 1.83337 11.4997C1.83337 6.43692 5.93729 2.33301 11 2.33301C16.0628 2.33301 20.1667 6.43692 20.1667 11.4997C20.1667 16.5624 16.0628 20.6663 11 20.6663ZM11 18.833C12.945 18.833 14.8102 18.0604 16.1855 16.6851C17.5608 15.3099 18.3334 13.4446 18.3334 11.4997C18.3334 9.55475 17.5608 7.68949 16.1855 6.31422C14.8102 4.93896 12.945 4.16634 11 4.16634C9.05512 4.16634 7.18986 4.93896 5.81459 6.31422C4.43932 7.68949 3.66671 9.55475 3.66671 11.4997C3.66671 13.4446 4.43932 15.3099 5.81459 16.6851C7.18986 18.0604 9.05512 18.833 11 18.833V18.833ZM11 16.9997V5.99967C12.4587 5.99967 13.8577 6.57914 14.8891 7.61059C15.9206 8.64204 16.5 10.041 16.5 11.4997C16.5 12.9584 15.9206 14.3573 14.8891 15.3888C13.8577 16.4202 12.4587 16.9997 11 16.9997Z"
              fill="currentColor"
            />
          </svg>
          {color === 'white' ? textData['text16'] : textData['text17']}
        </div>
      </div>
      <div>
        <img
          src={`http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-appearance-${color}-02.jpg`}
          alt=""
        />
      </div>
      <div>
        <img
          src={`http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-appearance-${color}-03.jpg`}
          alt=""
        />
      </div>
      <div>
        <div className={styles.textBox}>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text18']),
            }}
          ></h5>
          <h6
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text19']),
            }}
          ></h6>
        </div>
        <img
          src={`http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-appearance-04${language === 'cn' ? '' : '-en'}.jpg`}
          alt=""
        />
      </div>
      <div>
        <div className={styles.textBox}>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text20']),
            }}
          ></h5>
          <h6
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text21']),
            }}
          ></h6>
        </div>
        <img
          src="http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-appearance-05.jpg"
          alt=""
        />
      </div>
    </div>
  );
};

export default Id;
